export { default } from './DtrMultiLogsSummary.js';